export const MULTIPLE = 'multiple';
export const INDIVIDUAL = 'individual';

export const CAPACITIES = [
  {
    id: MULTIPLE,
    name: 'BOOKING.CAPACITY.MULTIPLE_CUSTOMERS.NAME',
    description: 'BOOKING.CAPACITY.MULTIPLE_CUSTOMERS.DESCRIPTION'
  },
  {
    id: INDIVIDUAL,
    name: 'BOOKING.CAPACITY.INDIVIDUAL.NAME',
    description: 'BOOKING.CAPACITY.INDIVIDUAL.DESCRIPTION'
  }
];
